import { render, staticRenderFns } from "./AnalyticsData.vue?vue&type=template&id=5f834963&scoped=true&"
import script from "./AnalyticsData.vue?vue&type=script&lang=js&"
export * from "./AnalyticsData.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsData.vue?vue&type=style&index=0&id=5f834963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f834963",
  null
  
)

export default component.exports